<template>
  <div>
    <p>
      The energy per bit to noise power density ratio
      <katex-element expression="E_b/N_0" /> will then by given (in
      <katex-element expression="dB" />) by:
    </p>
    <p>
      <katex-element
        expression="E_b/N_0 = \mathrm{EIRP} - L_{P,t} - L_{env} - L_{P,r} + G/T - 10\log{k_B} - 10\log{R}"
      />
    </p>
    <p>where:</p>
    <ul>
      <li>
        <katex-element expression="\mathrm{EIRP}" /> is the transmitter
        effective isotropic radiated power (<katex-element expression="dBW" />);
      </li>
      <li>
        <katex-element expression="L_{P,t}" /> is the transmitter pointing loss
        (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="L_{env}" /> is the sum of the environment
        losses (polarization, free-space path loss, atmospheric absorption,
        ionosphere, rain, visibility) (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="L_{P,r}" /> is the receiver pointing loss
        (<katex-element expression="dB" />);
      </li>
      <li>
        <katex-element expression="G/T" /> is the receiver gain to noise
        temperature (<katex-element expression="dB/K" />);
      </li>
      <li>
        <katex-element expression="k_B = 1.380649 \times 10^{-23}" /> is the
        Boltzmann constant (<katex-element expression="J⋅K^{-1}" />);
      </li>
      <li>
        <katex-element expression="R" /> is the desired data rate
        (<katex-element expression="bps" />);
      </li>
    </ul>
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipEquationEbN0'
}
</script>
